import { render } from "./Customers.html?vue&type=template&id=dd46dd4a&scoped=true"
import script from "./Customers.js?vue&type=script&lang=js"
export * from "./Customers.js?vue&type=script&lang=js"

import "./Customers.css?vue&type=style&index=0&id=dd46dd4a&scoped=true&lang=css"

import exportComponent from "/Users/blakegilbert/Documents/Projects/ShipTech/st-web-petro-network-admin-portal/src/ST.PetroNetworkAdmin.Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd46dd4a"]])

export default __exports__